<div
    style="
        max-width: 1000px;
        margin: 0 auto;
        padding: 80px 80px;
        border: 1px solid #ccc;
        border-radius: 10px;
        font-family: Arial, Helvetica, sans-serif;
    "
>
    <div
        style="
            font-size: 24px;
            font-weight: bold;
            text-align: center;
            text-decoration: underline;
        "
    >
        Credibility Interview Form
    </div>
    <div style="margin-top: 20px; background-color: #e9ebf6">
        <div
            style="display: flex; align-items: center; border: 1px solid black"
        >
            <div style="width: 50%; padding: 5px; display: flex">
                <b style="flex: none">Interview date:</b>
                <div
                    style="
                        width: 100%;
                        height: 100%;
                        outline: none;
                        border: none;
                        background-color: transparent;
                        font-weight: 600;
                        padding-left: 10px;
                    "
                >
                    25-07-2024
                </div>
            </div>
            <div
                style="
                    width: 50%;
                    border-left: 1px solid black;
                    padding: 5px;
                    display: flex;
                    align-items: center;
                    padding-left: 10px;
                "
            >
                <b style="flex: none">Name of interviewer:</b>
                <div
                    style="
                        width: 100%;
                        height: 100%;
                        outline: none;
                        border: none;
                        background-color: transparent;
                        font-weight: 600;
                        padding-left: 10px;
                    "
                >
                    {{ interviewDetails?.interviewerName }}
                </div>
            </div>
        </div>
        <div style="display: flex; border: 1px solid black">
            <div style="width: 33%; padding: 5px; display: flex">
                <b style="flex: none">Name/ID:</b>
                <div
                    style="
                        width: 100%;
                        height: 100%;
                        outline: none;
                        border: none;
                        background-color: transparent;
                        font-weight: 600;
                        padding-left: 10px;
                    "
                >
                    {{ interviewDetails?.studentName }}
                </div>
            </div>
            <div
                style="
                    width: 33%;
                    border-left: 1px solid black;
                    padding: 5px;
                    display: flex;
                    align-items: center;
                "
            >
                <b style="flex: none">DOB:</b>
                <div
                    style="
                        width: 100%;
                        height: 100%;
                        outline: none;
                        border: none;
                        background-color: transparent;
                        font-weight: 600;
                        padding-left: 10px;
                    "
                >
                    {{ interviewDetails?.dob }}
                </div>
            </div>
            <div
                style="
                    width: 33%;
                    border-left: 1px solid black;
                    padding: 5px;
                    display: flex;
                    align-items: center;
                "
            >
                <b style="flex: none">Nationality:</b>
                <div
                    style="
                        width: 100%;
                        height: 100%;
                        outline: none;
                        border: none;
                        background-color: transparent;
                        font-weight: 600;
                        padding-left: 10px;
                    "
                >
                    {{ questionAnswer?.questions?.additionalQuestion[7]?.answer }}
                </div>
            </div>
        </div>

        <div style="display: flex">
            <div
                style="
                    width: 75%;
                    border: 1px solid black;
                    padding: 5px;
                    display: flex;
                    align-items: center;
                "
            >
                <b style="flex: none">Course:</b>
                <div
                    style="
                        width: 100%;
                        height: 100%;
                        outline: none;
                        border: none;
                        background-color: transparent;
                        font-weight: 600;
                        padding-left: 10px;
                    "
                >
                    {{ interviewDetails?.courseName }}
                </div>
            </div>

            <div
                style="
                    width: 25%;
                    border: 1px solid black;
                    padding: 5px;
                    display: flex;
                    align-items: center;
                "
            >
                <b style="flex: none">Start date:</b>
                <b
                    style="
                        padding-left: 10px;
                        font-size: 12px;
                        font-style: italic;
                    "
                    >September 2024</b
                >
            </div>
        </div>
        <div style="display: flex">
            <div
                style="
                    width: 50%;
                    border: 1px solid black;
                    padding: 5px;
                    display: flex;
                    align-items: center;
                "
            >
                <b style="flex: none">Can you hear me clearly?</b>
                <div
                    style="
                        width: 100%;
                        height: 100%;
                        outline: none;
                        border: none;
                        background-color: transparent;
                        font-weight: 600;
                        padding-left: 10px;
                    "
                >
                    {{ questionAnswer?.questions?.radioData[2]?.answer }}
                </div>
            </div>
            <div
                style="
                    width: 50%;
                    border: 1px solid black;
                    padding: 5px;
                    display: flex;
                    align-items: center;
                "
            >
                <b style="flex: none">Is it a good time for the interview?</b>
                <div
                    style="
                        width: 100%;
                        height: 100%;
                        outline: none;
                        border: none;
                        background-color: transparent;
                        font-weight: 600;
                        padding-left: 10px;
                    "
                >
                    {{ questionAnswer?.questions?.additionalQuestion[2]?.answer }}
                </div>
            </div>
        </div>
        <div style="display: flex">
            <div
                style="
                    width: 50%;
                    border: 1px solid black;
                    padding: 5px;
                    display: flex;
                    align-items: center;
                "
            >
                <b style="flex: none">Passport shown:</b>
                <div
                    style="
                        width: 100%;
                        height: 100%;
                        outline: none;
                        border: none;
                        background-color: transparent;
                        font-weight: 600;
                        padding-left: 10px;
                    "
                >
                    {{ questionAnswer?.questions?.additionalQuestion[6]?.answer }}
                </div>
            </div>
            <div
                style="
                    width: 50%;
                    border: 1px solid black;
                    padding: 5px;
                    display: flex;
                    align-items: center;
                "
            >
                <b style="flex: none"
                    >Please indicate what region they are from:</b
                >
                <div
                    style="
                        width: 100%;
                        height: 100%;
                        outline: none;
                        border: none;
                        background-color: transparent;
                        font-weight: 600;
                        padding-left: 10px;
                    "
                >
                    {{ questionAnswer?.questions?.additionalQuestion[7]?.answer }}
                </div>
            </div>
        </div>
    </div>
    <table
        style="width: 100%; border-collapse: collapse; border: 1px solid black"
    >
        <tr style="background-color: #606eb2; color: white">
            <th style="border: 1px solid black; padding: 5px; width: 3%"></th>
            <th style="border: 1px solid black; padding: 5px; width: 20%">
                Question
            </th>
            <th style="border: 1px solid black; padding: 5px; width: 20%">
                Key Responses
            </th>
            <th style="border: 1px solid black; padding: 5px; width: 20%">
                Concerns
            </th>
            <th style="border: 1px solid black; padding: 5px; width: 15%">
                Comments
            </th>
            <th style="border: 1px solid black; padding: 5px; width: 3%">R</th>
            <th style="border: 1px solid black; padding: 5px; width: 3%">A</th>
            <th style="border: 1px solid black; padding: 5px; width: 3%">G</th>
        </tr>

        <ng-container
            *ngFor="let question of questionAnswer?.questions?.interviewQuestion"
        >
            <tr style="background-color: #dadada" *ngIf="question?.label">
                <td
                    style="
                        border: 1px solid black;
                        border-bottom: none;
                        padding: 0 5px;
                        background-color: #606eb2;
                        color: #fff;
                        text-align: center;
                    "
                >
                    <b>{{ question?.questionNo }})</b>
                </td>
                <td
                    colspan="4"
                    style="border-bottom: 1px solid #000; padding-left: 15px"
                >
                    <strong style="color: red">{{ question?.label }}</strong>
                </td>

                <td
                    style="
                        border: 1px solid black;
                        padding: 5px;
                        background-color: red;
                    "
                ></td>
                <td
                    style="
                        border: 1px solid black;
                        padding: 5px;
                        background-color: #ffc000;
                    "
                ></td>
                <td
                    style="
                        border: 1px solid black;
                        padding: 5px;
                        background-color: #92d050;
                    "
                ></td>
            </tr>

            <tr>
                <td
                    style="
                        border: 1px solid black;
                        padding: 0 5px;
                        background-color: #606eb2;
                        color: #fff;
                        text-align: center;
                    "
                >
                    <b *ngIf="!question?.label">{{ question?.questionNo }}.</b>
                </td>
                <td
                    style="
                        border: 1px solid black;
                        padding: 5px;
                        color: #000;
                        font-weight: 600;
                        vertical-align: top;
                    "
                >
                    {{ question?.question }}
                </td>
                <ng-container
                    *ngFor="let subQuestions of question?.subQuestions"
                >
                    <td style="border: 1px solid black; vertical-align: top">
                        <ng-container *ngFor="let subQuestion of subQuestions">
                            <div
                                style="
                                    display: flex;
                                    justify-content: space-between;
                                "
                            >
                                <div style="flex-grow: 1">
                                    <div
                                        style="
                                            display: flex;
                                            justify-content: space-between;
                                            border-bottom: 1px solid #000;
                                        "
                                    >
                                        <p
                                            style="
                                                margin: 0;
                                                padding: 10px;
                                                min-height: 30px;
                                                line-height: 1.2;
                                            "
                                        >
                                            {{ subQuestion?.question }}
                                        </p>
                                        <div
                                            type="text"
                                            style="
                                                background-color: #dbdde8;
                                                border: 2px solid #606eb2;
                                                outline: none;
                                                display: flex;
                                                align-items: center;
                                                justify-content: center;
                                                font-size: 20px;
                                                min-width: 30px;
                                            "
                                        >
                                            {{ subQuestion?.answer }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </td>
                </ng-container>

                <td style="border: 1px solid black; padding: 5px">
                    <textarea rows="3">{{ question?.answer }}</textarea>
                </td>
                <td
                    style="
                        border: 1px solid black;
                        padding: 5px;
                        background-color: red;
                    "
                >
                    <input
                        type="checkbox"
                        [checked]="question.decision === 'R'"
                    />
                </td>
                <td
                    style="
                        border: 1px solid black;
                        padding: 5px;
                        background-color: #ffc000;
                    "
                >
                    <input
                        type="checkbox"
                        [checked]="question.decision === 'A'"
                    />
                </td>
                <td
                    style="
                        border: 1px solid black;
                        padding: 5px;
                        background-color: #92d050;
                    "
                >
                    <input
                        type="checkbox"
                        [checked]="question.decision === 'G'"
                    />
                </td>
            </tr>
        </ng-container>
    </table>

    <div
        style="
            border: 1px solid black;
            margin-top: 10px;
            width: 50%;
            margin: 0 auto;
            margin-top: 30px;
            margin-bottom: 30px;
        "
    >
        <div
            style="
                padding: 5px;
                font-weight: bold;
                text-decoration: underline;
                display: flex;
                font-size: 16px;
            "
        >
            <span style="flex: none; padding: 5px 0">Final Decision</span>
            <input
                type="text"
                style="
                    background-color: #dbdde8;
                    width: 100%;
                    padding: 0;
                    outline: none;
                    border: 0;
                "
            />
        </div>
        <table style="width: 100%; border-collapse: collapse">
            <tr>
                <td
                    style="
                        padding: 10px;
                        border: 1px solid black;
                        border-left: 0;
                    "
                >
                    Pass
                </td>
                <td
                    style="
                        width: 20px;
                        border: 1px solid black;
                        text-align: center;
                        border-right: 0;
                        padding: 10px;
                    "
                >
                    <input
                        type="checkbox"
                        style="margin: 0"
                        [checked]="
                            questionAnswer?.questions?.additionalQuestion[0]?.answer ===
                            '0'
                        "
                    />
                </td>
            </tr>

            <tr>
                <td
                    style="
                        padding: 10px;
                        border: 1px solid black;
                        border-left: 0;
                    "
                >
                  Fail
                </td>
                <td
                    style="
                        width: 20px;
                        border: 1px solid black;
                        text-align: center;
                        border-right: 0;
                        padding: 10px;
                    "
                >
                    <input
                        type="checkbox"
                        style="margin: 0"
                        [checked]="
                            questionAnswer?.questions?.additionalQuestion[0]?.answer ===
                            '1'
                        "
                    />
                </td>
            </tr>
            <tr>
                <td
                    style="
                        padding: 10px;
                        border: 1px solid black;
                        border-left: 0;
                        border-bottom: 0;
                    "
                >
                Fail And Reschedule
                </td>
                <td
                    style="
                        width: 20px;
                        border: 1px solid black;
                        border-bottom: 0;
                        text-align: center;
                        border-right: 0;
                        padding: 10px;
                    "
                >
                    <input
                        type="checkbox"
                        style="margin: 0"
                        [checked]="
                            questionAnswer?.questions?.additionalQuestion[0]?.answer ===
                            '2'
                        "
                    />
                </td>
            </tr>
        </table>
    </div>

    <div style="border: 1px solid black; margin-top: 10px">
        <div
            style="
                padding: 5px;
                font-weight: bold;
                border-bottom: 1px solid #000;
            "
        >
            Please include Feedback
        </div>
        <div style="padding: 5px">
            <div style="padding: 5px">
                <b>Any previous refusals (any country):</b>
            </div>
            <div
                type="text"
                style="
                    width: 100%;
                    box-sizing: border-box;
                    background-color: #e6e6fa;
                    border: 0;
                    outline: 0;
                    padding: 5px;
                "
            >
                {{ questionAnswer?.questions?.additionalQuestion[8]?.answer }}
            </div>
            <div style="padding: 5px">
                <b>How many interviews were undertaken? :</b>
            </div>
            <div
                type="text"
                style="
                    width: 100%;
                    box-sizing: border-box;
                    background-color: #e6e6fa;
                    border: 0;
                    outline: 0;
                    padding: 5px;
                "
            >
                {{ questionAnswer?.questions?.additionalQuestion[2]?.answer }}
            </div>
            <div>
                <b style="padding: 5px"
                    >What areas did they have to improve on?</b
                >
                <textarea
                    rows="5"
                    style="
                        width: 100%;
                        box-sizing: border-box;
                        margin-top: 5px;
                        background-color: #e6e6fa;
                        border: 0;
                        outline: 0;
                    "
                    >{{
                        questionAnswer?.questions?.additionalQuestion[3]?.answer
                    }}</textarea
                >
            </div>
        </div>
    </div>
</div>
